import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 30,
  medium: 20,
  small: 14,
  xSmall: 10
};
const PlusIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "large":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 40 40",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { d: "M19.5 5V35H20.5V5H19.5Z", fill: "currentColor" }),
          /* @__PURE__ */ React.createElement("path", { d: "M5 19.5H35V20.5H5V19.5Z", fill: "currentColor" })
        );
      case "xSmall":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 16 16",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { d: "M7.64286 3V13H8.35714V3H7.64286Z", fill: "currentColor" }),
          /* @__PURE__ */ React.createElement("path", { d: "M3 7.64286H13V8.35714H3V7.64286Z", fill: "currentColor" })
        );
      case "small":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { d: "M9.5 3.5V17.5H10.5V3.5H9.5Z", fill: "currentColor" }),
          /* @__PURE__ */ React.createElement("path", { d: "M3 10H17V11H3V10Z", fill: "currentColor" })
        );
      case "medium":
      default:
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement("path", { d: "M14.5 5V25H15.5V5H14.5Z", fill: "currentColor" }),
          /* @__PURE__ */ React.createElement("path", { d: "M5 14.5H25V15.5H5V14.5Z", fill: "currentColor" })
        );
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderIcon());
};
PlusIcon.iconName = "PlusIcon";

export { PlusIcon };
